<template>
  <Slide class="ContactDetailsSupportSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="submitLead"
  >
    <p v-if="content.noticeHtml" class="notice" v-html="content.noticeHtml"></p>
    <InputFields @input="doUpdateField" @change="doUpdateField">
      <TextInput v-if="fieldConfig.imeiNumber.present"
        name="imeiNumber"
        :title="content.imeiNumberLabel"
        :info="content.imeiNumberInfo"
        :placeholder="content.imeiNumberPlaceholder"
        :value="fieldValues.imeiNumber"
        :error="fieldErrors.imeiNumber"
        :optional="!fieldConfig.imeiNumber.required"
        :disabled="!isCurrentSlide"
      />
      <TextAreaInput v-if="fieldConfig.comments.present"
        name="comments"
        :title="content.commentsLabel"
        :placeholder="content.commentsPlaceholder"
        :value="fieldValues.comments"
        :error="fieldErrors.comments"
        :optional="!fieldConfig.comments.required"
        :disabled="!isCurrentSlide"
      />
      <TextInput v-if="fieldConfig.phone.present"
        name="phone"
        :title="content.phoneLabel"
        :value="fieldValues.phone"
        :error="fieldErrors.phone"
        :optional="!fieldConfig.phone.required"
        :disabled="!isCurrentSlide"
      />
      <TextInput v-if="fieldConfig.email.present"
        name="email"
        :title="content.emailLabel"
        :value="fieldValues.email"
        :error="fieldErrors.email"
        :optional="!fieldConfig.email.required"
        :disabled="!isCurrentSlide"
      />
      <DataConsent
        :content="localeDataConsentContent"
        :fieldValues="fieldValues"
        :fieldErrors="fieldErrors"
      />
    </InputFields>
  </Slide>
</template>

<script>
import dataConsentContent from '../data/data-consent.json'
import { inputFieldsSlideMixin } from '../util/slideBuilders.js'

import DataConsent from './elems/DataConsent.vue'
import InputFields from './elems/InputFields.vue'
import Slide from './elems/Slide.vue'
import TextAreaInput from './elems/TextAreaInput.vue'
import TextInput from './elems/TextInput.vue'

export default {
  mixins: [inputFieldsSlideMixin],
  inject: ['locale'],
  components: {
    DataConsent,
    InputFields,
    Slide,
    TextAreaInput,
    TextInput,
  },
  computed: {
    localeDataConsentContent() {
      return dataConsentContent[this.locale]
    },
    fieldConfig() {
      return {
        imeiNumber: {
          present: this.formOptions.brand === 'inseego' && this.content.imeiNumberLabel,
          required: true,
        },
        comments: {
          present: Boolean(this.content.commentsPlaceholder),
          required: true,
        },
        phone: {
          present: true,
          required: false,
        },
        email: {
          present: true,
          required: true,
        },
        hasAcceptedPrivacyPolicy: {
          present: Boolean(this.localeDataConsentContent.privacyPolicyCheckbox),
          required: true,
        },
        hasConsentedToMarketing: {
          present: Boolean(this.localeDataConsentContent.marketingCheckbox),
          required: false,
        },
      }
    },
  },
}
</script>

<style scoped>
.notice {
  font-size: var(--font-size-2);
  color: var(--text-color-black);
  margin-bottom: var(--spacing-6);
}
</style>
